/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST + '/clb'
export const getClbProductTable = params => {
  return axios.post(`${base}/query_product`, params)
}
export const getClbProductDetail = params => {
  return axios.get(`${base}/getClbProductDetail/${params.id}`, {params})
}
export const exportClbProductData = params => {
  return axios.get(`${base}/exportClbProductData/${params.id}`, {params})
}
export const createClbProductData = params => {
  return axios.post(`${base}/createClbProductData`, params)
}
export const updateClbProductData = params => {
  return axios.post(`${base}/updateClbProductData/${params.id}`, params)
}
export const deleteClbProductData = params => {
  return axios.post(`${base}/deleteClbProductData/${params.id}`, params)
}
export const moveClbProductTo = params => {
  return axios.post(`${base}/move_product`, params)
}



// WEBPACK FOOTER //
// ./src/views/clb-product/clb-product.api.js